<template>
  <div v-if="internalValue!==undefined" class="color-picker-wrapp">
    <div class="title">{{ $t('color_op') }}</div>
    <div class="options-selector" @click="toggleDropdown">
      <div :class="'option-' + internalValue" :style="{background: cssGradient(options[internalValue])}" class="selected-option" />
      <div class="icon-wrapp">
        <div :class="dropdownOpen ? 'wrapper-open' : ''" class="icon-arrow" />
      </div>
    </div>
    <div v-if="dropdownOpen" :class="dropdownOpen && 'options-open'" class="options-wrapper">
      <div v-for="option in Object.keys(options)" :key="option">
        <div
          :class="'option-' + option"
          class="option"
          :style="{background: cssGradient(options[option])}"
          @click="changeSelectedColor(option)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cssGradient } from '@/utils/colorUtils'
export default {
  model: {
    prop: 'config',
    event: 'change-color',
  },
  props: {
    config: [String],
    options: [Object],
  },
  data() {
    return {
      dropdownOpen: false,
      // options: ['blue', 'yellow', 'green', 'orange', 'purple', 'multi'],
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.config
      },
      set(value) {
        this.$emit('change-color', value)
      },
    },
  },
  methods: {
    cssGradient,
    changeSelectedColor(op) {
      this.internalValue = op
      this.toggleDropdown()
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
  },
}
</script>

<style lang="stylus" scoped>
.color-picker-wrapp
  margin-bottom: vw(10px)

  .title
    m-font-size(14, 20)
    margin-bottom: vw(10px)
    font-weight: 600

  .options-selector
    display: flex
    padding: vw(10px)
    width: 100%
    border: 1px solid lightgrey
    border-radius: 3px
    gap: vw(8px)

    .selected-option
      width: 100%
      height: vw(25px)

    .icon-wrapp
      display: flex
      align-items: center
      background-color: white

      .icon-arrow
        m-icon("chevron-down", 24)
        transition: transform 0.25s ease-in-out
        transform-origin: 50% 55%

      .wrapper-open
        transform: rotate(180deg)

  .options-open
    transform-origin: top center
    animation: growDown 0.2s ease-in-out forwards

  .options-wrapper
    display: flex
    flex-direction: column
    padding: vw(10px)
    width: 100%
    border: 1px solid lightgrey
    border-radius: 3px
    gap: vw(10px)

    .option
      width: 100%
      height: vw(25px)

@keyframes growDown
  0%
    transform: scaleY(0)

  100%
    transform: scaleY(1)
</style>
